import React from "react";
import { useTranslation } from "react-i18next";
import config from "../../../../config";

export default function FooterInfo() {
  const { t } = useTranslation();
  return (
    <div className="u-mt--m">
      <h2 className="c-title--main border">
        {t("If the information you are looking for is not found")}
      </h2>
      <div className="c-contact">
        <div className="c-contact__row">
          <h2 className="c-contact__title">{t("Contact Us")}</h2>
          <div>
            <div className="c-button__list">
              <button
                type="button"
                className="c-button c-button--s c-button--blue"
                onClick={(e) => {
                  e.preventDefault();
                  window.location.href =
                    config.drupalPath.baseUrl +
                    config.drupalPath.pathPrefix +
                    "contact-us/inquiry";
                }}
              >
                {t("Making an inquiry using the form")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
